import { combineReducers } from "redux";
import {
  AllPatientRecordList,
  AuthHistory,
  DisciplineList,
  DocumentDownload,
  GetDisciplineDetailsReducer,
  GetDocumentListReducer,
  HealthPlanReducer,
  PatientHeader,
  RoleReducer,
  UpdateUserStatusReducer,
  UserModule,
  LogoutReducer,
} from "../reducers";

import GeneralInfoReducer from "../reducers/GetGeneralInfo";
import RequestDetailsReducer from "../reducers/GetRequestDetails";
import NotesListReducer from "../reducers/GetNotesList";
import NotesViewReducer from "../reducers/GetNotesView";
import User from "../reducers/User";
import ExchangedTokenReducer from "../reducers/GetExchangedToken";
import RefreshedTokenReducer from "../reducers/GetRefreshedToken";

const createRootReducer = combineReducers({
  generalInfoState: GeneralInfoReducer,
  requestDetailsState: RequestDetailsReducer,
  notesListState: NotesListReducer,
  notesViewState: NotesViewReducer,
  allPatientRecordState: AllPatientRecordList,
  userState: User,
  userModuleState: UserModule,
  authHistoryState: AuthHistory,
  disciplineListState: DisciplineList,
  documentListState: GetDocumentListReducer,
  documentDownloadState: DocumentDownload,
  patientHeaderState: PatientHeader,
  disciplineDetailsState: GetDisciplineDetailsReducer,
  roleState: RoleReducer,
  healthPlanMasterState: HealthPlanReducer,
  updateUserStatusState: UpdateUserStatusReducer,
  exchangedTokenState: ExchangedTokenReducer,
  refreshedTokenState: RefreshedTokenReducer,
  logoutState: LogoutReducer,
});

export default createRootReducer;
